var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:[{ active: _vm.visible }, { 'golf-main': _vm.isGolfService }]},[_c('span',[_vm._v(" 콘텐츠가 업데이트 되었습니다. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }